import * as _ from "lodash";
import loggingService from "common/logging/loggingService";
import featureFlags, { FeatureFlag, FeatureFlagCollection } from "./featureFlags";

export interface IFeatureFlagService {
    setValue(flag: string, value: boolean): void;
    loadFlags(): FeatureFlagCollection;
}

const FeatureFlagKey = "FeatureFlags";
const isProd = process.env.REACT_APP_UI_ENV === 'Prod';

class FeatureFlagService implements IFeatureFlagService {

    private overrides: {[k: string]: boolean} = {};

    constructor() {
        this.load();
    }

    public setValue(flag: keyof FeatureFlagCollection, value: boolean): void {
        if (featureFlags[flag] == null) {
            loggingService.error(`Feature flag ${flag} does not exist`);
            return;
        }

        this.overrides[flag] = value;

        localStorage.setItem(FeatureFlagKey, JSON.stringify(this.overrides));
    }

    public loadFlags(): FeatureFlagCollection {
        const flags = {...featureFlags};

        for(let key in this.overrides) {
            const flag = (flags as any)[key] as FeatureFlag;
            if (flag == null) continue;

            flag.currentValue = isProd && flag.isNonProdOnly === true
                ? flag.defaultValue
                : this.overrides[key];
        }

        return flags;
    }

    private load() {
        const fromStorage = localStorage.getItem(FeatureFlagKey);

        if (fromStorage != null) {
            this.overrides = JSON.parse(fromStorage);
        }
    }
}

const featureFlagService: IFeatureFlagService = new FeatureFlagService();


export default featureFlagService;